import React, { useState } from 'react';
import './Styles.css';
import { formatMessage } from '../../../../../../../Localization/formatMessage';
import Messages from '../../../../../../../Localization/Messages';
import { useGlobalAddressContext } from '../../AddressInfo';
import { PresentationMode } from '../../../../../../../Enums/PresentationMode';
import PrimaryButton from '../../../../../../../Elements/ids/Buttons/PrimaryButton';
import Select from '../../../../../../../Elements/ids/InputElements/Select';
import { ServiceClient } from '../../../../../../../Services/ServiceClient';
import { addressReducerTypes } from '../../Reducer';
import { useTeamPageContext } from '../../../../../TeamPage';
import { teamPageReducerTypes } from '../../../../../Reducer';
import { mapExistingAddressesToSelect } from './Functions';

const Error = () => {
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const {
    setModalMode,
    isModalOpenedOnTeamLevel,
    addressState,
    agentCode,
    codePrefix,
    addressDispatch,
  } = useGlobalAddressContext();

  const { teamPageDispatch } = useTeamPageContext();

  return (
    <>
      <div className="team-page_address-info_error-container">
        <>
          <p className="team-page_address-info_error-paragraph">
            {formatMessage(Messages.addressInfo_errorAddressNotFound)}
          </p>
          {addressState.addressList?.length > 0 && (
            <div className="team-page_address-info_error-existing-address-container">
              {formatMessage(Messages.addressInfo_errorSelectExistingAddress)}
              <div className="team-page_address-info_error-existing-address-inner-container">
                <Select
                  defaultValue={addressState.address?.id ?? 0}
                  options={mapExistingAddressesToSelect(addressState.addressList)}
                  onChange={e => {
                    setSelectedAddressId(e.target.value);
                  }}
                  cssClasses="max-width"
                />
                <PrimaryButton
                  text={formatMessage(Messages.common_update)}
                  onClickEvent={() => {
                    const address = addressState.addressList.find(x => x.id === parseInt(selectedAddressId));

                    if (isModalOpenedOnTeamLevel) {
                      ServiceClient.setAddressForTeam(codePrefix, selectedAddressId, () => {
                        addressDispatch({
                          type: addressReducerTypes.updateTeamAddressFromErrorView,
                          address,
                        });
                        teamPageDispatch({
                          type: teamPageReducerTypes.updateAddressInfo,
                          isModalOpenedOnTeamLevel,
                          address,
                        });
                        setModalMode(PresentationMode.View);
                      });
                    } else {
                      ServiceClient.setAddressForAgent(agentCode, selectedAddressId, () => {
                        addressDispatch({
                          type: addressReducerTypes.updateAgentAddressFromErrorView,
                          address,
                        });
                        teamPageDispatch({
                          type: teamPageReducerTypes.updateAddressInfo,
                          isModalOpenedOnTeamLevel,
                          address,
                        });
                        setModalMode(PresentationMode.View);
                      });
                    }
                  }}
                  disabled={!selectedAddressId}
                  isSmall={true}
                />
              </div>
            </div>
          )}
          <PrimaryButton
            text={formatMessage(Messages.addressInfo_errorCreate)}
            onClickEvent={() => {
              setModalMode(PresentationMode.Add);
            }}
            isSmall={true}
          />
        </>
      </div>
    </>
  );
};

export default Error;
